import { useState, useCallback, useRef, useMemo } from 'react';
import useEditor, {
  UseEditorOptions,
} from '@wix/da-editor-tiptap/pkg/hooks/useEditor';
import { MediaSelectorProps } from '../../MediaPopup/MediaSelector';
import { Props as EditorCommonProps } from '../EditorCommon/EditorCommon';
import { externalRenderers } from '../config';
import { MediaManagerProps } from '../../MediaPopup/MediaManager';
import { useCurrentUser } from '../../utils/hooks/useCurrentUser';

/**
 * Main hook for all consumers to use, creates a set of props
 * ready to use with the base editor components and ref to the
 * editorApi
 */
const useEditorNg = (options: UseEditorOptions) => {
  const { editorApi, editorProps } = useEditor(options);
  const currentUser = useCurrentUser();

  const [showMSProps, setshowMSProps] = useState<
    MediaSelectorProps | undefined
  >(undefined);

  const [showMMProps, setshowMMProps] = useState<MediaManagerProps | undefined>(
    undefined
  );

  const callbackMSRef = useRef<any>(null);
  const callbackMMRef = useRef<any>(null);

  const onSelectMedia = useCallback((cb, props) => {
    setshowMSProps(props ?? {});
    callbackMSRef.current = cb;
  }, []);

  const onManageMedia = useCallback((cb, props) => {
    setshowMMProps(props ?? {});
    callbackMMRef.current = cb;
  }, []);

  const editorSharedProps = useMemo(
    () => ({
      onSelectMedia,
      onManageMedia,
      externalRenderers,
      currentUser,
    }),
    [currentUser, onManageMedia, onSelectMedia]
  );

  const onSelect = useCallback(selected => {
    if (callbackMSRef.current) {
      setshowMSProps(undefined);
      callbackMSRef.current(selected);
    }
  }, []);

  const onManageDone = useCallback(selected => {
    if (callbackMMRef.current) {
      setshowMMProps(undefined);
      callbackMMRef.current(selected);
    }
  }, []);

  const editorCommonProps: EditorCommonProps = {
    onSelect,
    mediaSelectorProps: showMSProps,
    setMediaSelectorProps: setshowMSProps,
    mediaManagerProps: showMMProps,
    onManageDone,
    setMediaManagerProps: setshowMMProps,
  };

  return {
    editorApi,
    editorProps,
    editorSharedProps,
    editorCommonProps,
  };
};

export default useEditorNg;
